var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{ref:"drawer",attrs:{"app":"","left":_vm.side === 'left',"right":_vm.side != 'left',"clipped":_vm.side === 'left',"width":_vm.width,"value":_vm.show,"fixed":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }